import { SID, authenticatedUser } from '@state';
import { useRecoilValue } from 'recoil';

export const useGetShipperTokenHeader = () => {
	const sID = useRecoilValue(SID);
	const authUser = useRecoilValue(authenticatedUser);
	const shipperToken = sID && sID > 0 ? sID : authUser?.shipper?.id;
	const headers = shipperToken ? { 'X-Shipper-Token': `${shipperToken}` } : undefined;
	return headers;
}
